import { AUTH_SERVER, CLIENT_ID } from "../constants"

export const decodeJWT = (token:string) => {
    const arrytk = token.split(".")
    const payload = JSON.parse(atob( arrytk[1]))
    console.log(payload)
    return payload
}

export const redirectLogin = () => {
    // Construct the callback URL properly
    const baseUrl = window.location.origin;
    const callbackUrl = `${baseUrl}/auth/callback`;
    const encodedCallbackUrl = encodeURIComponent(callbackUrl);
    
    // Redirect to auth server with properly encoded parameters
    window.location.href = `${AUTH_SERVER}/sso?redir=${encodedCallbackUrl}&client=${CLIENT_ID}`;
}